module.exports = __webpack_public_path__ + "static/media/premium.888807f2.svg";